function injectStyle (ssrContext) {
  require("!!../../../node_modules/extract-text-webpack-plugin/dist/loader.js?{\"omit\":1,\"remove\":true}!vue-style-loader!css-loader?{\"sourceMap\":true}!../../../node_modules/vue-loader/lib/style-compiler/index?{\"vue\":true,\"id\":\"data-v-32e02a68\",\"scoped\":false,\"hasInlineConfig\":false}!sass-loader?{\"sourceMap\":true}!sass-resources-loader?{\"resources\":[\"/Users/user/Work/eu/12-16/newflipcard.ff.garena.all/src/frontend/main/src/assets/scss/variable.scss\",\"/Users/user/Work/eu/12-16/newflipcard.ff.garena.all/src/frontend/main/src/assets/scss/functions.scss\",\"/Users/user/Work/eu/12-16/newflipcard.ff.garena.all/src/frontend/main/src/assets/scss/mixins.scss\"]}!../../../node_modules/vue-loader/lib/selector?type=styles&index=0!./EuPolicyAlert.vue")
  require("!!../../../node_modules/extract-text-webpack-plugin/dist/loader.js?{\"omit\":1,\"remove\":true}!vue-style-loader!css-loader?{\"sourceMap\":true}!../../../node_modules/vue-loader/lib/style-compiler/index?{\"vue\":true,\"id\":\"data-v-32e02a68\",\"scoped\":false,\"hasInlineConfig\":false}!sass-loader?{\"sourceMap\":true}!sass-resources-loader?{\"resources\":[\"/Users/user/Work/eu/12-16/newflipcard.ff.garena.all/src/frontend/main/src/assets/scss/variable.scss\",\"/Users/user/Work/eu/12-16/newflipcard.ff.garena.all/src/frontend/main/src/assets/scss/functions.scss\",\"/Users/user/Work/eu/12-16/newflipcard.ff.garena.all/src/frontend/main/src/assets/scss/mixins.scss\"]}!../../../node_modules/vue-loader/lib/selector?type=styles&index=1!./EuPolicyAlert.vue")
}
var normalizeComponent = require("!../../../node_modules/vue-loader/lib/component-normalizer")
/* script */
export * from "!!babel-loader!../../../node_modules/vue-loader/lib/selector?type=script&index=0!./EuPolicyAlert.vue"
import __vue_script__ from "!!babel-loader!../../../node_modules/vue-loader/lib/selector?type=script&index=0!./EuPolicyAlert.vue"
/* template */
import __vue_template__ from "!!../../../node_modules/vue-loader/lib/template-compiler/index?{\"id\":\"data-v-32e02a68\",\"hasScoped\":false,\"transformToRequire\":{\"video\":[\"src\",\"poster\"],\"source\":\"src\",\"img\":\"src\",\"image\":\"xlink:href\"},\"buble\":{\"transforms\":{}}}!../../../node_modules/vue-loader/lib/selector?type=template&index=0!./EuPolicyAlert.vue"
/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __vue_script__,
  __vue_template__,
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

export default Component.exports



//////////////////
// WEBPACK FOOTER
// ./src/components/base/EuPolicyAlert.vue
// module id = null
// module chunks = 